jQuery(window).on("resize", function () {
  var distanceFromTop = jQuery(document).scrollTop();
  var headerHeight = jQuery(".header").outerHeight();
  if (distanceFromTop >= 0) {
    jQuery("#headerMenuheader").addClass("sticky");
    jQuery("body").addClass("sticky");
    jQuery("body").css("padding-top", headerHeight);
  } else {
    jQuery("#headerMenuheader").removeClass("sticky");
    jQuery("body").removeClass("sticky");
    jQuery("body").css("padding-top", "0px");
  }

  if (jQuery(window).width() < 1024) {
    jQuery(".sidebar-filters").css("padding-top", headerHeight);
    jQuery(".sidebar-filters form").css("height", "calc(100vh - " + headerHeight + "px - 90px)");

    jQuery("button.searchInputModal").click(function () {
      jQuery(".header .search-column").toggleClass("active");
      jQuery(this).toggleClass("active");
      // jQuery(window).trigger("resize");
      jQuery("input.searchInputModal").focus();
    });

    jQuery(".header .search-column").css("top", headerHeight);
  } else {
    jQuery(".sidebar-filters").css("padding-top", "inherit");
    // jQuery(".header .search-column .active").css("top", "inherit");

  }
});

jQuery(document).ready(function () {
  jQuery(window).trigger("resize");
});